import { PubSub, Subscriptions } from "Subscriptions"; 

class PageLoader {
    isLoading: boolean;
    requests: string[];

    constructor() {
        this.isLoading = false;
        this.requests = [];

        PubSub.subscribe(Subscriptions.App.UpdatePageViewModel, this.handleNewRoute);
    }

    trackRequest = (requestId, isComplete) => {
        // TODO: Take in a request and figure out the best way to handle its success
        let idx = this.requests.indexOf(requestId);

        if (isComplete && idx > -1) {
            // Remove Request
            this.requests.splice(idx, 1);
        } else if (!isComplete && idx === -1) {
            // Add Request or do nothing
            this.requests.push(requestId);
        }

        this.updateIsLoading();
    }

    private updateIsLoading = () => {
        if (this.requests.length > 0 && !this.isLoading) {
            this.isLoading = true;
            PubSub.publish(Subscriptions.Overlay.Targetted, {
                show: true,
                showLoader: true,
                target: '#mainContent',
                color: 'white',
                showAsFixed: true,
                additionalCssClass: 'overlay-front'
            });
        }
        else if (this.requests.length === 0 && this.isLoading) {
            this.isLoading = false;
            PubSub.publish(Subscriptions.Overlay.Targetted, {
                show: false,
                target: '#mainContent'
            });
        }
    }

    private handleNewRoute = (msg: string, data: any) => {
        // If we are not an empty component name!
        if (data.componentName) {
            this.requests = [];

            this.updateIsLoading();
        }
    }
}

var pageLoader = new PageLoader();
export default pageLoader;